/**
 * Customer-facing runtime flags. Each key must also be a backend flag with `browser=True` in
 * `paxton_app/featureflags/definitions.py`; a backend test fails when the two registries disagree.
 */
export const RuntimeFeatureFlag = {
  CITATION_HIGHLIGHTS_IMPROVEMENTS: 'citation-highlights-improvements',
  DOCX_EXPORT: 'docx-export',
  EMAIL_FILE_PROCESSING: 'email-file-processing',
  MATTER_OWNERSHIP_TRANSFER: 'matter-ownership-transfer',
  COLLAB_EDITOR_ROLE: 'collab-editor-role',
  TABLES: 'tables',
  POSTHOG_DEMO: 'posthog-demo',
  ONBOARDING_REFRESH: 'onboarding-refresh',
  // Release 1 settings-revamp foundation (account menu, settings navigation shell, Account & Billing).
  SETTINGS_REVAMP_FOUNDATION: 'settings-revamp-foundation',
} as const
export type RuntimeFeatureFlag = (typeof RuntimeFeatureFlag)[keyof typeof RuntimeFeatureFlag]

/** Used only when the Paxton API has not supplied a boolean. Matches the backend `remote_fallback`. */
export const featureFlagDefaults: Record<RuntimeFeatureFlag, boolean> = {
  [RuntimeFeatureFlag.CITATION_HIGHLIGHTS_IMPROVEMENTS]: false,
  [RuntimeFeatureFlag.DOCX_EXPORT]: false,
  [RuntimeFeatureFlag.EMAIL_FILE_PROCESSING]: false,
  [RuntimeFeatureFlag.MATTER_OWNERSHIP_TRANSFER]: false,
  [RuntimeFeatureFlag.COLLAB_EDITOR_ROLE]: false,
  [RuntimeFeatureFlag.TABLES]: true,
  [RuntimeFeatureFlag.POSTHOG_DEMO]: false,
  [RuntimeFeatureFlag.ONBOARDING_REFRESH]: false,
  [RuntimeFeatureFlag.SETTINGS_REVAMP_FOUNDATION]: false,
}
